import { render, staticRenderFns } from "./CustomTreeItem.vue?vue&type=template&id=1636c282&scoped=true"
import script from "./CustomTreeItem.vue?vue&type=script&lang=js"
export * from "./CustomTreeItem.vue?vue&type=script&lang=js"
import style0 from "./CustomTreeItem.vue?vue&type=style&index=0&id=1636c282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636c282",
  null
  
)

export default component.exports